<template>
    <v-tabs v-model="index" background-color="transparent" hide-slider fixed-tabs>
        <v-tab v-for="(tab, i) in tabs" :key="i" :value="tab.value" @click="setTab(tab)" :class="`custom-tab${color ? '-'+color : ''}`">
            {{ tab.label }}
        </v-tab>
    </v-tabs>
</template>

<script>
export default {
    name: "TabsGroup",
    props: {
        tabs: {
            type: Array,
            default: () => []
        },
        value: {
            type: [Number, String],
            default: null,
        },
        color: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            model: null,
            index: 0,
        }
    },
    mounted() {
        const vm = this;
        vm.setDefault()
    },
    methods: {
        setDefault() {
            const vm = this
            if (vm.value) {
                vm.model = vm.value
                vm.index = vm.tabs.findIndex(t => vm.model === t.value) || 0
            }
        },
        setTab(tab) {
            const vm = this;
            vm.model = tab?.value || tab
            vm.$emit('change', vm.model)
        }
    },
    watch: {
        value() {
            this.setDefault()
        },
    },

}
</script>

<style scoped>
.custom-tab {
    color: var(--v-primary-lighten1);
    border: 1px solid currentColor;
    transition: all 0.3s ease;
}

.custom-tab:hover {
    background-color: var(--v-primary-base);
    color: #000000 !important;
}

.v-tab--active.custom-tab {
    background-color: var(--v-primary-base);
    color: #000000 !important;
}

.custom-tab-grey {
    color: var(--v-backGroundPrimary-lighten1);
    border: 1px solid currentColor;
    transition: all 0.3s ease;
}

.custom-tab-grey:hover {
    background-color: var(--v-backGroundPrimary-base);
    color: #FFFFFF !important;
}

.v-tab--active.custom-tab-grey {
    background-color: var(--v-backGroundPrimary-base);
    color: #FFFFFF !important;
}
</style>